export const domain = {
    'role.admin': 'Administration',
    'role.member': 'Member',
    'role.admin.hint': 'May add and remove people, maintain the organisation’s templates and rename it.',
    'role.member.hint': 'May create, edit, share and present boards.',
    'visibility.private': 'Selected people only',
    'visibility.organisation': 'Everyone in the organisation',
    'plan.demo': 'Demo',
    'plan.demo.hint': 'For trying things out. Reset regularly.',
    'plan.klein': 'Small',
    'plan.klein.hint': 'For individual consultants and small offices.',
    'plan.team': 'Team',
    'plan.team.hint': 'For agencies working on boards together.',
    'plan.gross': 'Large',
    'plan.gross.hint': 'For companies with several teams and a lot of media.',
    'license.state.aktiv': 'Active',
    'license.state.laeuft-ab': 'Expiring',
    'license.state.abgelaufen': 'Expired',
    'license.state.loeschung-faellig': 'Due for deletion',
    'license.notice.expiring.one': 'The licence expires in {count} day. After that, no new boards can be created.',
    'license.notice.expiring.many': 'The licence expires in {count} days. After that, no new boards can be created.',
    'license.notice.expired.one': 'The licence has expired. Existing boards remain usable, but nothing new can be created. In {count} day the data will be marked for deletion.',
    'license.notice.expired.many': 'The licence has expired. Existing boards remain usable, but nothing new can be created. In {count} days the data will be marked for deletion.',
    'license.notice.deletion': 'The licence expired more than three weeks ago. This organisation is marked for deletion — please contact Digitalwart immediately.',
    'license.expired.short': 'This organisation’s licence has expired.',
    'font.sans': 'Grotesque (default)',
    'font.serif': 'Serif',
    'font.grotesk': 'Condensed',
    'font.mono': 'Monospace',
    'font.rounded': 'Rounded',
    'share.explore.label': 'Free viewing',
    'share.explore.description': 'The guest moves around the board freely and can navigate to frames themselves. They cannot change anything.',
    'share.guided.label': 'Guided, with freedom to move',
    'share.guided.description': 'The guest only sees the board once the presentation starts, then follows your view. They can break away and return at any time.',
    'share.locked.label': 'Strictly guided',
    'share.locked.description': 'Like “Guided”, but the guest cannot break away: they see only what you are showing.',
    'scope.personal': 'Only for me',
    'scope.personal.hint': 'Stays in your own list; nobody else sees it.',
    'scope.organisation': 'For the organisation',
    'scope.organisation.hint': 'Every member of this organisation can use it.',
    'scope.platform': 'For all organisations',
    'scope.platform.hint': 'Provider’s default template — available in every organisation.',
    'background.black': 'Deep black',
    'background.anthracite': 'Anthracite',
    'background.night': 'Night blue',
    'background.warmgrey': 'Warm grey',
    'background.slate': 'Slate',
    'background.sand': 'Sand',
    'background.paper': 'Paper',
    'background.white': 'Pure white',
    'viewport.monitor': 'Large monitor',
    'viewport.desktop': 'Desktop',
    'viewport.laptop': 'Laptop',
    'viewport.tabletLandscape': 'Tablet landscape',
    'viewport.tablet': 'Tablet',
    'viewport.phone': 'Phone',
    'bt.talk': 'Talk',
    'bt.talk.title': 'Title',
    'bt.talk.agenda': 'Agenda',
    'bt.talk.topic1': 'Topic 1',
    'bt.talk.topic2': 'Topic 2',
    'bt.talk.topic3': 'Topic 3',
    'bt.talk.conclusion': 'Conclusion',
    'bt.talk.questions': 'Questions',
    'bt.client': 'Client meeting',
    'bt.client.welcome': 'Welcome',
    'bt.client.situation': 'Starting point',
    'bt.client.proposal': 'Proposal',
    'bt.client.delivery': 'Delivery',
    'bt.client.effort': 'Effort',
    'bt.client.next': 'Next steps',
    'bt.workshop': 'Workshop',
    'bt.workshop.arrive': 'Arriving',
    'bt.workshop.goal': 'Goal of the day',
    'bt.workshop.rules': 'Ground rules',
    'bt.workshop.space1': 'Work area 1',
    'bt.workshop.space2': 'Work area 2',
    'bt.workshop.parking': 'Parking lot',
    'bt.workshop.results': 'Results',
    'bt.lesson': 'Teaching unit',
    'bt.lesson.start': 'Introduction',
    'bt.lesson.goals': 'Learning goals',
    'bt.lesson.work': 'Working through',
    'bt.lesson.practice': 'Practice',
    'bt.lesson.secure': 'Consolidation',
    'bt.lesson.outlook': 'Outlook',
    'bt.mood': 'Moodboard',
    'bt.mood.direction': 'Direction',
    'bt.mood.colors': 'Colours',
    'bt.mood.type': 'Typography',
    'bt.mood.imagery': 'Imagery',
    'bt.mood.references': 'References',
    'bt.mood.boundaries': 'Out of scope',
    'bt.canvas': 'Large canvas',
    'bt.canvas.frame': 'Canvas',
};
//# sourceMappingURL=domain.js.map